module.exports = __webpack_public_path__ + "6a96e083155c66418726af7844d831ca.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/img16-9-nakazuka.jpg
 ** module id = 511
 ** module chunks = 1
 **/